import { render, staticRenderFns } from "./lrAreaSelect.vue?vue&type=template&id=36b8931e&"
import script from "./lrAreaSelect.vue?vue&type=script&lang=js&"
export * from "./lrAreaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports